/*
 * Arrow buttons for the brand carousels (customer reviews, video carousel).
 * Each button scrolls the track named in data-target by one card.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest('.carousel-arrow');

  if (!button) {
    return;
  }

  const track = document.getElementById(button.dataset.target);

  if (!track) {
    return;
  }

  const card = track.firstElementChild;
  const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
  const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;

  track.scrollBy({ left: step * Number(button.dataset.direction), behavior: 'smooth' });
});

/*
 * Magnifier button on review photos: opens the photo in a full-screen dialog.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-zoom-src]');

  if (!button) {
    return;
  }

  let dialog = document.getElementById('review-lightbox');

  if (!dialog) {
    dialog = document.createElement('dialog');
    dialog.id = 'review-lightbox';
    dialog.className = 'review-lightbox';
    dialog.innerHTML = '<img alt=""><button type="button" class="review-lightbox__close" aria-label="Close">&times;</button>';
    dialog.addEventListener('click', (closeEvent) => {
      if (closeEvent.target === dialog || closeEvent.target.closest('.review-lightbox__close')) {
        dialog.close();
      }
    });
    document.body.appendChild(dialog);
  }

  const image = dialog.querySelector('img');
  image.src = button.dataset.zoomSrc;
  image.alt = button.dataset.zoomAlt || '';
  dialog.showModal();
});
